import { IRestaurant } from '../restaurant/restaurant.types';
import { FILE_FORMAT } from '../files/files.types';
import { TicketPaymentStatus } from '../ticket/ticket.types';

export interface CreateOrUpdateTermsBody {
  restaurantId: number;
  employeeId?: string;
  type: 'Create' | 'Update';
}

export interface ImportedGiftCard {
  restaurantId: number;
  amount: number;
  images: string;
}

export enum USER_GIFT_STATUS {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  PAID = 'paid',
}

export enum USER_GIFT_TYPE {
  SELF = 'self',
  GIFT = 'gift',
}

export enum RECIPIENT_DETAIL_TYPE {
  SEND_AS_EMAIL = 'send-as-email',
  SEND_AS_TEXT = 'send-as-text',
}

export enum FIND_GIFT_BY {
  PHONE = 'check_by_phone',
  GIFT_NUMBER = 'check_by_gift_number',
}

export enum SELECTED_GIFT_RECIPIENT {
  SOMONE_ELSE = 'Someone else',
  MYSELF = 'Myself',
}

export enum COPYRIGHT_MESSAGE {
  SENTENCE = '© Copyright 2026. All Rights Reserved by AIO APP, INC.',
}

export interface UserPurchaseGiftCard {
  cardImageUrl: string;
  amount: number;
  isCustom: boolean;
  senderName: string;
  senderEmail: string;
  recipientName: string;
  recipientEmail: string;
  recipientPhoneNumber: string; // this is used for both sender and recipient, both numbers will not exist at same time
  selectedGiftRecipient: SELECTED_GIFT_RECIPIENT;
  personalNote?: string | null;
  giftCardId?: string | null;
  userGiftcardId?: number | null;
  termsAndConditionsSelected: boolean;
  isPromotionsSubscribed: boolean;
  categoryName?: string;
}
export interface UserGiftCards {
  id: string;
  balance: number;
  gift_card_number: string;
  gift_card_id: number;
  initial_amount: string;
  gift_image_url: string;
  s3FileUrl: string;
  reload_amount: number | null;
}
export interface GiftCardSettings {
  id: number;
  maxAmount: number;
  minAmount: number;
  presetAmounts: number[];
  onlinePinEnabled: boolean;
  restaurantId: number;
}
export interface GiftCardTemplateCategories {
  id: number;
  name: string;
  giftCards: GiftCard[];
}

export interface GiftCard {
  id: number;
  amount: number;
  images: string[];
  restaurant: IRestaurant;
  imageUrl: string;
  categoryName?: string;
}

export interface UserGiftCard {
  id: number | string;
  gift_card_number: string;
  giftCardHash: string;
  status: string;
  gift_type: string;
  security_code: number;
  initial_amount: number | string;
  balance: number;
  message: string;
  purchased_by_name: string;
  purchased_by_email: string;
  purchased_by_phone: string;
  recipient_name: string;
  recipient_email: string;
  recipient_phone: string;
  gift_card_id: number;
  recipient_id?: number;
  gift_image_url: string;
  s3FileUrl: string;
  purchased_by_id?: number;
  payment_id?: number;
  businessId?: number;
  restaurantId: number;
  businessAlias?: string;
  restaurantAlias: string;
  giftCard: GiftCard;
  reload_amount: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface Decoded_Token_Online {
  id: string;
  paymentType: string;
  businessId?: number;
  restaurantId?: number;
  create_account?: boolean;
  setPromotions?: boolean;
  loginAllowed?: boolean;
  businessAlias?: string;
  restaurantAlias?: string;
  userGiftCard?: UserGiftCard;
  restaurant?: IRestaurant;
  reloadBalance?: boolean;
  reloadAmount?: number;
  convenienceFee?: number;
}

export interface LookUpCard {
  id: number;
  gift_card_number: string;
  initial_amount: number;
  balance: number;
  createdAt: string;
  recipient_email: string | null;
  recipient_name: string | null;
  recipient_phone: string | null;
  message: string | null;
  gift_type: USER_GIFT_TYPE;
}

export interface TotalBalance {
  data: string;
}

export interface IGiftCardInventoryImport {
  businessId: number;
  restaurantId: number;
  jobGuid: string;
  accountId: string;
  totalCount: number;
  outputSignedUrl: string;
  callbackUrl: string;
  expiresAt: string;
  baseUrl: string;
  giftCardsArray: string[];
  batchIndex: number;
}
export enum USER_GIFT_CARD_TYPE {
  DIGITAL = 'digital',
  PHYSICAL = 'physical',
}

export enum MIGRATED_GIFT_CARD_STATUS {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  VOIDED = 'Voided',
}

export enum GIFT_CARD_INVENTORY_STATUS {
  IN_STOCK = 'in_stock',
  PURCHASED = 'purchased',
}

export enum GIFT_CARD_SOURCE {
  INVENTORY = 'inventory',
  MIGRATED = 'migrated',
  PHYSICAL = 'physical',
  DIGITAL = 'digital',
}

export const IMPORT_FILE_FORMATS = [FILE_FORMAT.XLSX, FILE_FORMAT.XLS, FILE_FORMAT.CSV];

export const IMPORT_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export enum PLATFORM_OPTIONS {
  CAKE = 'cake',
}

export const PLATFORM_DEFINITIONS: Record<PLATFORM_OPTIONS, Record<string, string>> = {
  [PLATFORM_OPTIONS.CAKE]: {
    cardNumber: '`PRINTED_NUMBER`',
    balance: '`AVAILABLE_BALANCE_ON_CARD`',
  },
};

export interface GiftCardTicket {
  id: number;
  ticketNumber: number;
  ticketPaymentStatus: TicketPaymentStatus;
  totalAmountInCents: number;
  discountAmountInCents?: number;
  discountPercentage?: number;
  employeeUserRestaurantId: number;
  restaurantId: number;
  cognitoCreatedAt: Date;
  cognitoUpdatedAt: Date;
  cognitoCreatedBy: string;
  cognitoUpdatedBy: string;
}

export enum GIFT_CARD_TABS {
  MY_CARDS = 'My Cards',
  EXPLORE = 'Explore',
}

export enum GIFT_CARD_EXPLORE_TABS {
  PURCHASE_GIFT_CARD = 'Purchase gift card',
  CHECK_BALANCE_RELOAD = 'Check balance/Reload',
}
